import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProfilePage from './pages/ProfilePage';
import DocumentsPage from './pages/DocumentsPage';
import PoliciesPage from './pages/PoliciesPage';
import PrintOffsPage from './pages/PrintOffsPage';
import BiblePage from './pages/BiblePage';
import LoginPage from './pages/LoginPage';
import PolicyViewer from './pages/PolicyViewer';
import DevArchivePage from './pages/DevArchivePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex min-h-screen bg-gray-100">
          <Sidebar />
          <div className="flex-1">
            <Header />
            <main className="p-6">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/about" element={<ProtectedRoute><AboutPage /></ProtectedRoute>} />
                <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path="/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
                <Route path="/policies" element={<ProtectedRoute><PoliciesPage /></ProtectedRoute>} />
                <Route path="/printoffs" element={<ProtectedRoute><PrintOffsPage /></ProtectedRoute>} />
                <Route path="/bible" element={<ProtectedRoute><BiblePage /></ProtectedRoute>} />
                <Route path="/policy/:policyId" element={<ProtectedRoute><PolicyViewer /></ProtectedRoute>} />
                <Route path="/dev-archive" element={<ProtectedRoute><DevArchivePage /></ProtectedRoute>} />
              </Routes>
            </main>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}
    export default function AppRoot() {
      return (
        <AuthProvider>
          <App />
        </AuthProvider>
      );
    }